import script from "./RouterLinkCustom.vue?vue&type=script&setup=true&lang=ts"
export * from "./RouterLinkCustom.vue?vue&type=script&setup=true&lang=ts"

import "./RouterLinkCustom.vue?vue&type=style&index=0&id=556970a2&lang=scss"

const __exports__ = script;

export default __exports__